<div *ngIf="isLoading">
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
</div>

<div *ngIf="!isLoading">
  <mat-tab-group #tabGroup mat-stretch-tabs>
    <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.StoreInfoTabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-store-info [xpac]="xpac"></xpac-store-info>
      </ng-template>
    </mat-tab>
    <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.XpacTabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-xpac-details [xpac]="xpac"></xpac-xpac-details>
      </ng-template>
    </mat-tab>
    @if('devices' | hasPermission : 'Device_Devices' : 'read' | async) {
    <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.DevicesTabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-devices [xpac]="xpac"></xpac-devices>
      </ng-template>
    </mat-tab>
    }
    <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.LicenseTabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-xpac-license [xpac]="xpac"></xpac-xpac-license>
      </ng-template>
    </mat-tab>
    <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.OrdersTabHeader' | translate }}">
      <ng-template matTabContent>
        <xpac-xpac-orders [xpac]="xpac"></xpac-xpac-orders>
      </ng-template>
    </mat-tab>
    <ng-container *ngIf="('devices' | hasPermission : 'Device_Logging' : 'read' | async)">
      <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.LoggingTabHeader' | translate }}">
        <ng-template matTabContent>
          <xpac-xpac-logging [xpac]="xpac"></xpac-xpac-logging>
        </ng-template>
      </mat-tab>
    </ng-container>
    <ng-container *ngIf="('devices' | hasPermission : 'Device_XpacTelemetry' : 'read' | async)">
      <mat-tab label="{{ 'Modules.XPACManagementComponent.XpacInfoComponent.TelemetryTabHeader' | translate }}">
        <ng-template matTabContent>
          <xpac-xpac-telemetry [xpac]="xpac"></xpac-xpac-telemetry>
        </ng-template>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
</div>